import {
  Typography,
  Box,
  Button,
  Card,
  CardContent,
  useMediaQuery,
  useTheme,
  Grid,
  DialogActions,
  Divider,
  DialogContent,
  Dialog,
  TextField,
  Stack,
  Menu,
  MenuItem,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MyArrayInput from "../MyArrayInput";

import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import WorkIcon from "@mui/icons-material/Work";
import LanguageIcon from "@mui/icons-material/Language";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import warning_logo from "../../assets/img/warning_icon.svg";
import coin_icon from "../../assets/img/coin_icon.svg";
import target_icon from "../../assets/img/target_icon.svg";
import mode_icon from "../../assets/img/mode_icon.svg";
import { styled } from "@mui/material/styles";
import logo from "../../assets/img/new_logo.svg";
import colors from "colors/color";
import clock_icon from "../../assets/img/clock_icon.svg";
import expand_icon from "../../assets/img/expand_icon.svg";
import pencil_icon from "../../assets/img/pencil_icon.svg";
import threedot_icon from "../../assets/img/tree_points.svg";
import white_save_icon from "../../assets/img/unlock_icon.svg";
import expired_icon from "../../assets/img/expired_icon.svg";
import { useTranslation } from "react-i18next";
import useUserId from "hooks/useUserId";
import { COLORS } from "colors/color";
import save_icon from "../../assets/img/lock_icon.svg";
import ShareIcon from "@mui/icons-material/Share";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import { NewPostButton } from "components/Buttons/Buttons";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import EditPostDetailsDialog from "./Dialogs/EditPostDetailsDialog";
import EditWorkingDetailsDialog from "./Dialogs/EditWorkingDetailsDialog";
import QRCodeDialog from "./QRCodeDialog";
import reference_icon from "../../assets/img/reference_icon.svg";
import SimpleAlert from "components/Dialog/SimpleAlert";
import { useCallback } from "react";
const JobCardContainer = styled(Card)(({ theme }) => ({
  border: "1px solid #F0F0F0",
  backgroundColor: "#FFFFFF",
  padding: theme.spacing(3, 3, 0.5),
  borderRadius: 20,
  maxWidth: "100%",
  [theme.breakpoints.up("md")]: {
    maxWidth: "313px",
  },
  minWidth: "auto",
  flex: "0 0 auto",
  height: "100%",
  maxHeight: "auto",
  display: "flex",
  flexDirection: "column",
  boxShadow: "none",
  // cursor: "pointer",
  transition: "all 0.8s ease",
  "&:hover": {
    boxShadow: "0px 4px 20px rgba(0, 23, 231, 0.1)",
    borderColor: "#0017E7",
    transition: "all 0.3s ease",
  },
  position: "relative",
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2, 2, 1),
  },
}));
const StyledDialog = styled(Dialog)({
  "& .MuiDialog-paper": {
    borderRadius: "15px",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
  },
});
const CompanyLogo = styled(Box)(({ theme, logo }) => ({
  minWidth: "59px",
  minHeight: "59px",
  maxWidth: "59px",
  maxHeight: "59px",
  background:
    "linear-gradient(135deg, rgba(0, 23, 231, 0.5) -54.69%, rgba(255, 204, 248, 0.5) 66.41%)",
  borderRadius: 14,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  fontSize: "0.75rem",
  textAlign: "center",
}));

const PostingChip = styled(Box)(({ theme }) => ({
  borderRadius: 8,
  borderWidth: 0.3,
  p: "15px",
  gap: 10,
  backgroundColor: "#0017E70D",
  border: "0.3px solid #0017E7",
  maxWidth: "119px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

// Modified ExpiryChip to accept color prop
const ExpiryChip = styled(Box)(({ theme, color = "#FBBC05" }) => ({
  backgroundColor: `${color}33`, // 33 is for 20% opacity
  color: color,
  padding: "5px 15px 5px 15px",
  borderRadius: "8px",
  fontSize: "8px",
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
  border: `0.3px solid ${color}`,
  minWidth: "120px",
  justifyContent: "center",
  whiteSpace: "nowrap",
  maxHeight: 25,
}));

const DetailItem = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  fontSize: "12px",
  fontWeight: 500,
  fontFamily: "Poppins",
}));

const SaveButton = styled(Button)(({ theme, variant }) => ({
  maxWidth: 1,
  width: 1,
  height: 44,
  borderRadius: "11px",
  borderWidth: "1px",
  border: "1px solid #0017E7",
  color: "#0017E7",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "rgba(61, 90, 254, 0.04)",
    borderColor: "#3D5AFE",
  },
  padding: "0",
}));

const ActionButton = styled(Button)(({ theme, variant }) => ({
  borderRadius: 11,
  padding: theme.spacing("12px", "24px", "12px", "24px"),
  textTransform: "none",
  fontWeight: 400,
  fontFamily: "Poppins",
  border: variant === "outlined" ? "1px solid #0017E7" : "none",
  color: variant === "outlined" ? "#0017E7" : "#fff",
  backgroundColor: variant === "outlined" ? "transparent" : "#0017E7",
  "&:hover": {
    backgroundColor:
      variant === "outlined" ? "rgba(61, 90, 254, 0.04)" : "#0017E7",
    borderColor: variant === "outlined" ? "#3D5AFE" : "none",
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing("8px", "16px", "8px", "16px"),
    fontSize: "0.75rem",
  },
  whiteSpace: "nowrap",
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    width: "auto",
  },
}));
const ActionButton2 = styled(Button)(
  ({ theme, variant, isArchived, close }) => ({
    width: 44,
    height: 44,
    minWidth: 44,
    borderRadius: 11,
    padding: 0,
    textTransform: "none",
    fontWeight: 400,
    fontFamily: "Poppins",
    border: isArchived ? "1px solid #00BA19" : "1px solid #0017E7",
    color: isArchived ? "#0017E7" : "#fff",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "rgba(61, 90, 254, 0.04)",
      borderColor: close ? "rgb(84, 255, 107)" : "#3D5AFE",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: 40,
      minWidth: "100%",
    },
  })
);
const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    fontFamily: "Poppins",
    borderColor: "#00000033",
    backgroundColor: "#fff",
    transition: "border-color 0.4s ease, box-shadow 0.4s ease",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#e0e0e0",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      boxShadow: "0px 4px 20px rgba(0, 23, 231, 0.1)",
      borderColor: "#0017E7",
      transition: "all 0.3s ease",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      boxShadow: "0px 4px 20px rgba(0, 23, 231, 0.1)",
      borderColor: "#0017E7",
      transition: "all 0.3s ease",
    },
    "& .MuiOutlinedInput-input": {
      minHeight: "36px",
      padding: "8px 14px",
    },
  },
}));
const TruncatedTypography = styled(Typography)({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  display: "block",
});
const StyledDatePicker = styled(DatePicker)({
  "& .MuiOutlinedInput-root": {
    height: 56,
    borderRadius: "10px",
    fontFamily: "Poppins",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#e0e0e0",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      boxShadow: "0px 4px 20px rgba(0, 23, 231, 0.1)",
      borderColor: "#0017E7",
      transition: "all 0.3s ease",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      boxShadow: "0px 4px 20px rgba(0, 23, 231, 0.1)",
      borderColor: "#0017E7",
      transition: "all 0.3s ease",
    },
  },
});
export default function JobCardRec({
  job,
  setSelectedJob,
  setOpenDialog,
  postid,
  imageSrc,
  archived,
  onArchivePost,
  updatePost,
  onDeletePost,
  onSelectPost,
  isArchived,
  companyLogo,
  company,
  setUpdatedData,
  onUpdateSuccess
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const openDetailsDialog = () => {
    setSelectedJob(job);
    setOpenDialog(true);
  };
  const [postTitle, setPostTitle] = useState(job.title || "");
  const [postDescription, setPostDescription] = useState(job.description || "");
  const [postRequirement, setPostRequirement] = useState(
    job.requirements || []
  );
  const [postDeadline, setPostDeadline] = useState(job.deadline || "");
  const [postToDeleteId, setPostToDeleteId] = useState(null);
  const [open4, setOpen4] = useState(false);
  const [open5, setOpen5] = useState(false);
  const { t } = useTranslation();
  const userId = useUserId();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  // Add errors state object
  const [errors, setErrors] = useState({
    postTitle: "",
    postDescription: "",
    offerType: "",
    reference: "",
    accountType: "",
    workingMode: "",
    location: "",
    postImage: "",
  });

  // States for EditWorkingDetailsDialog
  const [workingMode, setWorkingMode] = useState(job.mode || "Remote");
  const [location, setLocation] = useState(job.localisation || "");
  const [numPeople, setNumPeople] = useState(job.age_experience || "");
  const [salary, setSalary] = useState(job.salary || "");
  const [currency, setCurrency] = useState(job.currency || "MAD");
  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedScr, setIsCheckedScr] = useState(false);
  const [experience, setExperience] = useState(job.experiences || "");
  const [diploma, setDiploma] = useState(job.highest_diploma || "");
  const [otherDiploma, setOtherDiploma] = useState("");
  const [fieldOfStudy, setFieldOfStudy] = useState(job.field_of_study || "");
  const [otherFieldOfStudy, setOtherFieldOfStudy] = useState("");
  const [postImage, setPostImage] = useState(job.image || imageSrc || "");
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  // Menu state
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const openMenu = Boolean(menuAnchorEl);
  const [openQRCodeDialog, setOpenQRCodeDialog] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [openalert, setOpenalert] = React.useState(false);
  const [normalizedCoefficients, setNormalizedCoefficients] = useState(null);
  const [accountType, setAccountType] = useState(job.accountType || "");
  const [reference, setReference] = useState(job.reference || "");
  const [recruiterEmail, setRecruiterEmail] = useState(
    job.recruiter_email || ""
  );

  const fetchCountApplicationByPost = async (postId) => {
    try {
      const response = await fetch(
        `${apiUrl}authentication/application/counter/${postId}/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("response counter data", data);


      // Return the counter value
      return data.counter;

    } catch (error) {
      console.error("Error fetching application count:", error);
      return 0; // Return 0 on error
    }
  };



  useEffect(() => {
    // Generate QR code URL when post ID changes
    if (postid) {
      const baseUrl = window.location.origin;
      const encodedId = btoa(postid);
      const jobUrl = `${baseUrl}/viewjob/${encodedId}`;
      setQrCodeUrl(jobUrl);
    }

  }, [postid]);
  // Add offerType state for EditPostDetailsDialog
  const [offerType, setOfferType] = useState(
    job.offerType === "i" ? "internship" : "job"
  );
  const [skills, setSkills] = useState(job.skills || []);

  // Update useEffect to properly handle offerType
  useEffect(() => {
    if (job) {
      setSalary(job.salary || "");
      setCurrency(job.currency || "MAD");
      // Map the offerType from backend format ('i'/'j') to frontend format
      setOfferType(job.offerType === "i" ? "internship" : "job");
      setWorkingMode(job.mode || "Remote");
      setLocation(job.localisation || "");
      setNumPeople(job.age_experience || "");
      setPostTitle(job.title || "");
      setPostDescription(job.description || "");
      setPostRequirement(job.requirements || []);
      setPostDeadline(job.deadline || "");
      setPostImage(job.image || imageSrc || "");
      setExperience(job.experiences || "");
      setDiploma(job.highest_diploma || "");
      setFieldOfStudy(job.field_of_study || "");
    }
  }, [job]);

  const handleMenuClick = (event) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (event) => {
    event.stopPropagation();
    setMenuAnchorEl(null);
  };

  const handleShare = (event) => {
    event.stopPropagation();
    // Implement share functionality here
    console.log("Share job:", postid);
    setMenuAnchorEl(null);
    setOpenQRCodeDialog(true);
  };
  useEffect(() => {
    console.log("job:==", job);
  }, [job]);

  // Handler functions for EditWorkingDetailsDialog
  const handleSalaryChange = (value) => {
    console.log("Salary changing to:", value); // Debug log
    setSalary(value);
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleCheckboxChangeScr = (event) => {
    setIsCheckedScr(event.target.checked);
  };

  const handleImageUpload = (image) => {
    setPostImage(image);
    setErrors((prev) => ({ ...prev, postImage: "" }));
  };

  const handleNext = () => {
    // Validate form
    const newErrors = {};

    if (!postTitle.trim()) {
      newErrors.postTitle = t("errors.requiredField");
    }

    if (!postDescription.trim()) {
      newErrors.postDescription = t("errors.requiredField");
    }

    if (!offerType) {
      newErrors.offerType = t("errors.requiredField");
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Move to second dialog
    setOpen4(false);
    setOpen5(true);
  };
  const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  };
  const handleNormalizedCoefficientsChange = useCallback((normalizedCoefficients) => {
    setNormalizedCoefficients(normalizedCoefficients);
  }, []); // Empty array since setNormalizedCoefficients is stable

  const handleSave = (secondDialogData) => {
    // Format the data to match API expectations
    const completeUpdateData = {
      postId: postid,
      title: postTitle,
      description: postDescription,
      experiences: stripHtmlTags(postDescription),
      requirements: postRequirement,
      deadline: postDeadline,
      reference: reference || null,
      mode: secondDialogData.mode,
      localisation: secondDialogData.localisation,
      age_experience: secondDialogData.age_experience || null,
      salary: secondDialogData.salary !== "" ? secondDialogData.salary : null,
      offerType: offerType === "internship" ? "i" : "j", // Ensure correct format for backend
      image: secondDialogData.image,
      field_of_study: secondDialogData.field_of_study,
      highest_diploma: secondDialogData.highest_diploma,
      currency: secondDialogData.currency || currency,
      coefficients: normalizedCoefficients
    };

    console.log("Sending update with data2:", completeUpdateData);
    // Call the update function
    updatePost(completeUpdateData)
      .then((success) => {
        if (success) {
          setPostTitle(postTitle);
          setSalary(secondDialogData.salary);
          setCurrency(secondDialogData.currency);
          setWorkingMode(secondDialogData.mode);
          // Keep the frontend format when updating local state
          setOfferType(offerType);
        }
      })
      .catch((error) => {
        console.error("Error updating post:", error);
      });
  };

  async function handleUpdatePost() {
    setOpen4(false);
    setOpen5(true);
  }

  // Calculate deadline color and message
  const [deadlineInfo, setDeadlineInfo] = useState({
    color: "#FBBC05", // Default orange
    message: "Days to expire",
    daysRemaining: 0,
    icon: "",
  });

  // Add dateError state
  const [dateError, setDateError] = useState("");

  // Add handleDateChange function if it doesn't exist
  const handleDateChange = (newValue) => {
    const dateOnly = newValue ? dayjs(newValue).format("YYYY-MM-DD") : null;

    if (newValue && dayjs(newValue).isBefore(dayjs().add(1, "day"), "day")) {
      setDateError(t("errors.dateMustBeTomorrowOrLater"));
      setPostDeadline(null);
    } else {
      setDateError("");
      setPostDeadline(dateOnly);
    }
  };

  useEffect(() => {
    const calculateTimeRemaining = () => {
      if (!job.deadline) {
        return {
          color: "#FBBC05",
          message: t("jobCard.deadline.notSet"),
          value: 0,
        };
      }

      let deadlineDate = new Date(job.deadline);
      if (isNaN(deadlineDate.getTime())) {
        return {
          color: "#FBBC05",
          message: t("jobCard.deadline.invalidDate"),
          value: 0,
        };
      }

      const now = new Date();
      const diffMs = deadlineDate - now;
      const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

      // Expired
      if (days < 0) {
        return {
          color: "#FF0000",
          message: t("jobCard.deadline.expired"),
          value: 0,
          icon: expired_icon,
        };
      }

      // Under a week: show days
      if (days < 7) {
        return {
          color: "#FF0000",
          message: t(
            days === 1
              ? "jobCard.deadline.daysToExpire"
              : "jobCard.deadline.daysToExpire_plural",
            { count: days }
          ),
          value: days,
          icon: warning_logo,
        };
      }

      // Under a month: show weeks
      if (days < 30) {
        const weeks = Math.ceil(days / 7);
        return {
          color: colors.primary,
          message: t(
            weeks === 1
              ? "jobCard.deadline.weeksToExpire"
              : "jobCard.deadline.weeksToExpire_plural",
            { count: weeks }
          ),
          value: weeks,
        };
      }

      // A month or more: show months
      const months = Math.ceil(days / 30);
      return {
        color: colors.primary,
        message: t(
          months === 1
            ? "jobCard.deadline.monthsToExpire"
            : "jobCard.deadline.monthsToExpire_plural",
          { count: months }
        ),
        value: months,
      };
    };

    setDeadlineInfo(calculateTimeRemaining());
  }, [job.deadline, t]);

  const handleArchiveChange = async (event) => {
    event.stopPropagation();

    const animationDuration = 500;
    await new Promise((resolve) => setTimeout(resolve, animationDuration));
    await onArchivePost(postid, true);
  };

  const handleEditClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setOpen4(true);
  };

  const handleDeleteClick = async (event) => {
    event.stopPropagation();
    const resultCount = await fetchCountApplicationByPost(postid);
    if (resultCount > 0) {
      console.log('Archive ', resultCount)
      setOpenalert(true)
    } else {
      console.log('Delete ', resultCount)
      setPostToDeleteId(postid);
      setOpenDeleteDialog(true);
    }
  };
  const handleCloseAlert = () => {
    setOpenalert(false);
  };

  function formatToDDmmmYYYY(isoString) {
    const d = new Date(isoString);
    if (isNaN(d)) return "";
    const day = String(d.getDate()).padStart(2, "0");
    const months = [
      "jan",
      "feb",
      "mar",
      "apr",
      "may",
      "jun",
      "jul",
      "aug",
      "sep",
      "oct",
      "nov",
      "dec",
    ];
    const mon = months[d.getMonth()];
    const year = d.getFullYear();
    return `${day} ${mon} ${year}`;
  }
  useEffect(() => {
    console.log("job---:", job);
  }, [job]);
  const formattedDate = job.date ? formatToDDmmmYYYY(job.date) : "";

  // Update the salary display section
  const renderSalarySection = () => (
    <DetailItem sx={{ color: "#0017E7" }}>
      <Box
        component="img"
        src={coin_icon}
        sx={{
          width: { xs: 16, sm: 20 },
          height: { xs: 16, sm: 20 },
          display: "inline-flex",
          paddingBottom: 0.2,
        }}
      />
      <TruncatedTypography
        sx={{ fontWeight: 500, fontSize: { xs: "10px", sm: "12px" } }}
      >
        {job.salary || t("jobCard.notAvailable")}
      </TruncatedTypography>
      {job.salary && (
        <>
          <Typography sx={{ fontSize: isMobile ? "9px" : "inherit" }}>
            {job.currency || ""}
          </Typography>
          <Typography
            sx={{
              color: "#00000080",
              fontWeight: 300,
              fontSize: isMobile ? "9px" : "inherit",
            }}
          >
            {t("jobCard.salary.perMonth")}
          </Typography>
        </>
      )}
    </DetailItem>
  );

  // Update the job type display section
  const renderJobTypeSection = () => (
    <DetailItem sx={{ color: "#0017E7", mb: 2 }}>
      <Box
        component="img"
        src={target_icon}
        sx={{
          width: { xs: 16, sm: 20 },
          height: { xs: 16, sm: 20 },
          display: "inline-flex",
          paddingBottom: 0.2,
        }}
      />
      <TruncatedTypography sx={{ fontSize: { xs: "10px", sm: "12px" } }}>
        {job.offerType === "i" ? t("jobCard.internship") : t("jobCard.job")}
      </TruncatedTypography>
    </DetailItem>
  );
  const renderReferenceSection = () => (
    <DetailItem sx={{ color: "#0017E7", mb: 2 }}>
      <Box
        component="img"
        src={reference_icon}
        sx={{
          width: { xs: 16, sm: 20 },
          height: { xs: 16, sm: 20 },
          display: "inline-flex",
          paddingBottom: 0.2,
        }}
      />
      <TruncatedTypography sx={{ fontSize: { xs: "10px", sm: "12px" } }}>
        {job.reference}
      </TruncatedTypography>
    </DetailItem>
  );

  return (
    <JobCardContainer>
      <CardContent
        onClick={onSelectPost}
        sx={{
          padding: 0,
          display: "flex",
          flexDirection: "column",
          // height: "100%",
          cursor: 'pointer'
        }}
      >
        {/* Top content section */}  
        <Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              mb: 2,
            }}
          >
            <CompanyLogo logo={companyLogo || logo}>
              <img
                src={job.image}
                alt={companyLogo}
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                  padding: "0px",
                }}
              />
            </CompanyLogo>
            <Box sx={{ width: "100%", overflow: "hidden" }}>
              {/* First line: Title and Expiry Chip */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0.5,
                  width: "100%",
                  flexWrap: { xs: "wrap", sm: "nowrap" },
                }}
              >
                <TruncatedTypography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: "14px", sm: "16px" },
                    fontFamily: "Poppins",
                    textTransform: "none",
                    maxWidth: { xs: "calc(100% - 50px)", sm: "160px" },
                    mb: { xs: 1, sm: 0 },
                  }}
                >
                  {job.title || "Senior React Js"}
                </TruncatedTypography>
                <ActionButton2
                  onClick={handleMenuClick}
                  aria-controls={openMenu ? "job-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openMenu ? "true" : undefined}
                >
                  <img
                    src={threedot_icon}
                    style={{
                      width: isMobile ? 14 : 18,
                      height: isMobile ? 14 : 18,
                    }}
                  />
                </ActionButton2>
                <Menu
                  id="job-menu"
                  anchorEl={menuAnchorEl}
                  open={openMenu}
                  onClose={handleMenuClose}
                  onClick={(e) => e.stopPropagation()}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      mt: 1,
                      borderRadius: 2,
                      "& .MuiMenuItem-root": {
                        px: 2,
                        py: 1,
                        fontFamily: "Poppins",
                        fontSize: 14,
                      },
                      border: "1px solid #F0F0F0",
                      backgroundColor: "#FFFFFF",
                      boxShadow: "none",
                      transition: "all 0.8s ease",
                      "&:hover": {
                        boxShadow: "0px 4px 20px rgba(0, 23, 231, 0.1)",
                        borderColor: "#0017E7",
                        transition: "all 0.3s ease",
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "left", vertical: "top" }}
                  anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
                >
                  <MenuItem onClick={handleShare}>
                    <ShareIcon
                      fontSize="small"
                      sx={{ mr: 1.5, color: "#0017E7" }}
                    />
                    {t("jobCard.menu.share")}
                  </MenuItem>
                  <MenuItem onClick={handleDeleteClick}> {/* onClick={handleArchiveChange} */}
                    <DeleteIcon
                      fontSize="small"
                      sx={{ mr: 1.5, color: "#FF0000" }}
                    />
                    {t("jobCard.menu.delete")}
                  </MenuItem>
                  {/* {job.is_archived ? (
                    <MenuItem onClick={handleArchiveChange}>
                      <img
                        src={white_save_icon}
                        style={{
                          width: 14,
                          height: 14,
                          marginRight: 10,
                        }}
                      />
                      {t('jobCard.menu.unarchive')}
                    </MenuItem>
                  ) : (
                    <MenuItem onClick={handleArchiveChange}>
                      <img
                        src={save_icon}
                        style={{
                          width: 14,
                          height: 14,
                          marginRight: 10,
                        }}
                      />
                      {t('jobCard.menu.archive')}
                    </MenuItem>
                  )} */}
                </Menu>
              </Box>
              <Box>
                <PostingChip>
                  <Box
                    component="img"
                    src={clock_icon}
                    sx={{
                      width: 12,
                      height: 12,
                      marginBottom: 0.5,
                      marginTop: 0.5,
                    }}
                  />
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: 8,
                      lineHeight: 1,
                      letterSpacing: 0,
                      color: colors.primary,
                    }}
                  >
                    {t("jobCard.posted")}{" "}
                    {formattedDate || t("jobCard.noDateSet")}
                  </Typography>
                </PostingChip>
              </Box>
            </Box>
          </Box>
          <Box>
            <Grid container sx={{ mt: 2, mb: 2 }}>
              <Grid item xs={12}>
                {/* Modified ExpiryChip with dynamic color based on deadline */}
                <ExpiryChip color={deadlineInfo.color}>
                  <Box
                    component="img"
                    src={deadlineInfo.icon}
                    sx={{
                      width: 12,
                      height: 12,
                      display: "inline-flex",
                      paddingBottom: 0.2,
                    }}
                  />
                  <Typography variant="caption">
                    {deadlineInfo.message}
                  </Typography>
                </ExpiryChip>
              </Grid>
            </Grid>
          </Box>
          {/* Job Details Row */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: { xs: 1, sm: 2 },
              mb: 2,
              justifyContent: "flex-start",
            }}
          >
            {renderSalarySection()}
            <DetailItem sx={{ color: "#0017E7" }}>
              <Box
                component="img"
                src={mode_icon}
                sx={{
                  width: { xs: 16, sm: 20 },
                  height: { xs: 16, sm: 20 },
                  display: "inline-flex",
                  paddingBottom: 0.2,
                }}
              />
              <TruncatedTypography
                sx={{ fontSize: { xs: "10px", sm: "12px" } }}
              >
                {job.mode || "Remote"}
              </TruncatedTypography>

            </DetailItem>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: { xs: 1, sm: 2 },
              mb: 2,
              justifyContent: "flex-start",
            }}
          >
            {renderJobTypeSection()}
            {job.reference !== null ? renderReferenceSection() : null}
          </Box>

          {job.skills && typeof job.skills === "object" && (
            <DetailItem sx={{ color: "#0017E7", mb: 0 }}>
              <Box
                component="img"
                src={target_icon}
                sx={{
                  width: { xs: 16, sm: 20 },
                  height: { xs: 16, sm: 20 },
                  display: "inline-flex",
                  paddingBottom: 0,
                }}
              />
              <TruncatedTypography
                sx={{ fontSize: { xs: "10px", sm: "12px" } }}
              >
                {Object.values(job.skills).join(", ")}
              </TruncatedTypography>
            </DetailItem>
          )}
        </Box>
        {/* Action Buttons - placed at the bottom with fixed position */}
        <Grid container sx={{ mt: "auto", pt: 0 }} spacing={2}>
          {/* <Grid item xs={12} sm={6}>
            <ActionButton
              variant="outlined"
              sx={{
                gap: 1,
                width: "100%",
                minHeight: "44px",
                "&:hover": {
                  backgroundColor: "primary.main",
                  color: "white",
                  "& img": {
                    filter: "brightness(0) invert(1)",
                  }
                }
              }}
              onClick={onSelectPost}
            >
              <img
                src={expand_icon}
                style={{
                  width: isMobile ? 14 : 18,
                  height: isMobile ? 14 : 18,
                  transition: "filter 0.3s ease",
                }}
              />
              <TruncatedTypography
                sx={{ fontSize: { xs: "12px", sm: "14px" } }}
              >
                {t("jobCard.openOffer")}
              </TruncatedTypography>
            </ActionButton>
          </Grid> */}

          <Grid item xs={6} sm={6}>
            <NewPostButton
              sx={{
                gap: 1,
                width: "100%",
                height: "100%",
                minHeight: "44px",
                justifyContent: "center",
                "&:hover": {
                  backgroundColor: "primary.main",
                  color: "white",
                  "& img": {
                    filter: "brightness(0) invert(1)",
                  }
                },
              }}
              onClick={handleEditClick}
            >
              <img
                src={pencil_icon}
                style={{
                  width: isMobile ? 14 : 14,
                  height: isMobile ? 14 : 14,
                  transition: "filter 0.3s ease",
                }}
              />
              {!isMobile && (
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontWeight: 400,
                    fontSize: "12px",
                    display: { xs: "none", sm: "block" },
                  }}
                >
                  {/* {t("jobCard.actions.edit")} */}
                </Typography>
              )}
            </NewPostButton>
          </Grid>

          <Grid item xs={6} sm={6}>
            <ActionButton2
              isArchived={isArchived}
              onClick={handleArchiveChange}
              close={true}
              sx={{
                width: "100%",
                height: "100%",
                minHeight: "44px",
                "&:hover": {
                  backgroundColor: "primary.main",
                  color: "white",
                  "& img": {
                    filter: "brightness(0) invert(1)",
                  }
                }
              }}
            >
              <img
                src={isArchived ? white_save_icon : save_icon}
                style={{
                  transition: "filter 0.3s ease",
                }}
              />
            </ActionButton2>
          </Grid>
        </Grid>
      </CardContent>
      <EditPostDetailsDialog
        setOpen={setOpen4}
        postTitle={postTitle}
        setPostTitle={setPostTitle}
        postDescription={postDescription}
        setPostDescription={setPostDescription}
        offerType={offerType}
        setOfferType={setOfferType}
        postRequirement={postRequirement}
        setPostRequirement={setPostRequirement}
        postDeadline={postDeadline}
        handleDateChange={handleDateChange}
        handleNext={handleNext}
        open={open4}
        errors={errors}
        dateError={dateError}
        setDateError={setDateError}
        showRef={job.scraped}
        accountType={job.accountType}
        setAccountType={setAccountType}
        reference={job.reference}
        setReference={setReference}
        recruiterEmail={job.recruiter_email}
        setRecruiterEmail={setRecruiterEmail}
        setErrors={setErrors}
      />
      <EditWorkingDetailsDialog
        setOpen2={setOpen5}
        setOpen={setOpen4}
        open2={open5}
        errors={errors}
        setErrors={setErrors}
        postTitle={postTitle}
        postDescription={postDescription}
        offerType={offerType}
        postRequirement={postRequirement}
        postDeadline={postDeadline}
        accountType={job.accountType}
        reference={job.reference}
        recruiterEmail={job.recruiter_email}
        handleDateChange={handleDateChange}
        handleImageUpload={handleImageUpload}
        workingMode={workingMode}
        setWorkingMode={setWorkingMode}
        location={location}
        setLocation={setLocation}
        numPeople={numPeople}
        setNumPeople={setNumPeople}
        salary={salary}
        handleSalaryChange={handleSalaryChange}
        currency={currency}
        setCurrency={setCurrency}
        isChecked={isChecked}
        handleCheckboxChange={handleCheckboxChange}
        isCheckedScr={isCheckedScr}
        handleCheckboxChangeScr={handleCheckboxChangeScr}
        handleSave={handleSave}
        experience={experience}
        setExperience={setExperience}
        diploma={diploma}
        setDiploma={setDiploma}
        otherDiploma={otherDiploma}
        setOtherDiploma={setOtherDiploma}
        fieldOfStudy={fieldOfStudy}
        setFieldOfStudy={setFieldOfStudy}
        otherFieldOfStudy={otherFieldOfStudy}
        setOtherFieldOfStudy={setOtherFieldOfStudy}
        job={job}
        onUpdateSuccess={onUpdateSuccess}
        onNormalizedCoefficientsChange={handleNormalizedCoefficientsChange}
      />
      <Dialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        onClick={(e) => e.stopPropagation()}
        PaperProps={{
          sx: {
            width: 270,
            height: 168,
            m: 0,
            borderRadius: 5,
            position: "relative",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 600,
              color: "black",
              mb: 1,
              fontFamily: "Poppins",
              pt: 2,
              px: 2,
            }}
          >
            {t("cardPost.deleteConfirmationTitle")}
          </Typography>
          <Divider
            sx={{
              mb: 1,
              borderColor: "#0000001A",
              borderWidth: "2px",
              width: "100%",
            }}
          />
          <Typography
            variant="caption"
            sx={{
              color: "#00000080",
              mb: 2,
              fontSize: 12,
              fontFamily: "Poppins",
              px: 2,
            }}
          >
            {t("cardPost.deleteConfirmationMessage")}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            px: 4,
            pb: 2,
          }}
        >
          <Grid
            container
            spacing={1}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid item xs={12} md={6} lg={6}>
              <Button
                variant="outlined"
                onClick={() => setOpenDeleteDialog(false)}
                sx={{
                  width: 100,
                  height: 40,
                  borderRadius: 2,
                  borderColor: "#0084ff",
                  color: "#0084ff",
                  textTransform: "none",
                  fontFamily: "Poppins",
                  fontSize: 13,
                  fontWeight: "400px",
                }}
              >
                {t("cardPost.cancelButton")}
              </Button>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Button
                variant="contained"
                onClick={() => {
                  onDeletePost(postToDeleteId);
                  setOpenDeleteDialog(false);
                }}
                sx={{
                  width: 100,
                  height: 40,
                  borderRadius: 2,
                  bgcolor: "#ff0000",
                  color: "white",
                  textTransform: "none",
                  fontSize: 13,
                  fontFamily: "Poppins",
                  fontWeight: "400px",
                  "&:hover": {
                    bgcolor: "#ff0000",
                  },
                }}
              >
                {t("cardPost.deleteButton")}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <QRCodeDialog
        open={openQRCodeDialog}
        onClose={() => setOpenQRCodeDialog(false)}
        qrCodeUrl={qrCodeUrl}
        formData={job}
        callerComponent="JobCardRec"
      />
      <SimpleAlert
        open={openalert}
        onClose={handleCloseAlert}
        text="Cette offre ne peut pas être Supprimée car elle contient des candidatures, vous pavez l'archiver."
        type='warning'
      />
    </JobCardContainer>
  );
}
